import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Adoption from './pages/Adoption';
import ReleasePet from './pages/ReleasePet';
import AboutUs from './pages/AboutUs';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Animal from './pages/Animal';
import AdoptForm from './pages/AdoptForm';

const baseurl = 'https://dog.ceo/api/breed/';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [animalNames, setAnimalNames] = useState([
    { id: 0, name: 'Ace', description: 'Ace is a very playful dog who loves to fetch and run around. He is very friendly and gets along well with other dogs. Ace is looking for an active family who can give him plenty of exercise and attention.', gender: 'Male', age: '4 years', breed: 'Dachshund', color: 'brown' },
    { id: 1, name: 'Bella', description: 'Bella is a gentle dog who enjoys lounging in sunny spots. She is very affectionate and loves to be petted. Bella would do best in a quiet home where she can relax and enjoy her surroundings.', gender: 'Female', age: '3 years', breed: 'Husky', color: 'cream' },
    { id: 2, name: 'Chloe', description: 'Chloe is a curious dog who loves to explore her surroundings. She is very social and enjoys being around people. Chloe needs a home where she can have plenty of space to hop around and play.', gender: 'Female', age: '2 years', breed: 'Beagle', color: 'black and white' },
    { id: 3, name: 'Daisy', description: 'Daisy is a friendly dog who loves to meet new people and other dogs. She is very outgoing and enjoys going on walks and playing in the park. Daisy would be a great addition to an active family.', gender: 'Female', age: '5 years', breed: 'Labrador', color: 'yellow' },
    { id: 4, name: 'Luna', description: 'Luna is a calm dog who enjoys being petted and sitting on laps. She is very gentle and gets along well with other dogs. Luna would do best in a home where she can have plenty of attention and affection.', gender: 'Female', age: '4 years', breed: 'Poodle', color: 'gray' },
    { id: 5, name: 'Max', description: 'Max is an energetic dog who loves to play tug-of-war and go on walks. He is very playful and enjoys being around people. Max needs a home where he can have plenty of exercise and playtime.', gender: 'Male', age: '3 years', breed: 'Beagle', color: 'tricolor' },
    { id: 6, name: 'Oliver', description: 'Oliver is a playful dog who loves to chase toys and climb. He is very curious and enjoys exploring his surroundings. Oliver would do best in a home where he can have plenty of toys and space to play.', gender: 'Male', age: '1 year', breed: 'Dalmatian', color: 'orange' },
    { id: 7, name: 'Oscar', description: 'Oscar is a laid-back dog who enjoys napping and watching birds. He is very relaxed and gets along well with other dogs. Oscar would be a great addition to a quiet home where he can enjoy his naps.', gender: 'Male', age: '6 years', breed: 'Malamute', color: 'blue' },
    { id: 8, name: 'Penny', description: 'Penny is a sweet dog who loves to cuddle and give kisses. She is very affectionate and enjoys being around people. Penny would do best in a home where she can have plenty of attention and love.', gender: 'Female', age: '2 years', breed: 'Poodle', color: 'white' },
    { id: 9, name: 'Sophie', description: 'Sophie is a shy dog who takes time to warm up but is very affectionate once she does. She is very gentle and enjoys being petted. Sophie needs a home where she can feel safe and loved.', gender: 'Female', age: '5 years', breed: 'Maltese', color: 'seal point' }
  ]);

  useEffect(() => {
    const fetchDogImages = async () => {
      const updatedAnimalNames = await Promise.all(animalNames.map(async (animal) => {
        try {
          const response = await fetch(`${baseurl}${animal.breed.toLowerCase()}/images/random`);
          const data = await response.json();
          return { ...animal, imageUrl: data.message };
        } catch (error) {
          console.error('Error fetching the dog image:', error);
          return animal;
        }
      }));
      setAnimalNames(updatedAnimalNames);
    };

    fetchDogImages();
  }, []);

  const handleLogin = (username) => {
    setIsLoggedIn(true);
    setUsername(username);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername('');
  };

  return (
    <Router>
      <Navbar isLoggedIn={isLoggedIn} username={username} onLogout={handleLogout} />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/adoption" element={<Adoption animal={animalNames} />} />
          <Route path="/release-pet" element={<ReleasePet />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/animal" element={<Animal animal={animalNames} />} />
          <Route path="/adoptform" element={<AdoptForm animal={animalNames} />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;